import { ProFormColumnsType } from '@ant-design/pro-components';
import { FormattedMessage } from 'react-intl';

export const createPercentageShareholdingFormItem = (isRequired = false): ProFormColumnsType =>
  ({
    title: (
      <FormattedMessage id='btlApplicationForm.TOP_SLICING_HOUSEHOLD.member.income.percentageShareholding.label' />
    ),
    dataIndex: ['percentageShareholding'],
    valueType: 'digit',
    width: 200,
    fieldProps: {
      precision: 0,
      min: 1,
      max: 100,
      suffix: '%',
    },
    formItemProps: {
      hasFeedback: isRequired,
      rules: [
        {
          required: isRequired,
          message: <FormattedMessage id='common.error.requiredField' />,
        },
        {
          type: 'number',
          min: 1,
          message: <FormattedMessage id='common.error.minNumber' values={{ min: 1 }} />,
        },
        {
          type: 'number',
          max: 100,
          message: <FormattedMessage id='common.error.maxNumber' values={{ max: 100 }} />,
        },
      ],
    },
  } as ProFormColumnsType);
